export var BirthControlMethod = /*#__PURE__*/function (BirthControlMethod) {
  BirthControlMethod[BirthControlMethod["NONE"] = 1] = "NONE";
  BirthControlMethod[BirthControlMethod["OTHER"] = 2] = "OTHER";
  BirthControlMethod[BirthControlMethod["PILL"] = 3] = "PILL";
  BirthControlMethod[BirthControlMethod["CONDOM"] = 4] = "CONDOM";
  BirthControlMethod[BirthControlMethod["SHOT"] = 5] = "SHOT";
  BirthControlMethod[BirthControlMethod["NUVA_RING"] = 6] = "NUVA_RING";
  BirthControlMethod[BirthControlMethod["IMPLANT"] = 7] = "IMPLANT";
  BirthControlMethod[BirthControlMethod["HORMONAL_UID"] = 8] = "HORMONAL_UID";
  BirthControlMethod[BirthControlMethod["PULL_OUT"] = 9] = "PULL_OUT";
  BirthControlMethod[BirthControlMethod["COPPER_IUD"] = 10] = "COPPER_IUD";
  BirthControlMethod[BirthControlMethod["PATCH"] = 11] = "PATCH";
  BirthControlMethod[BirthControlMethod["VASECTOMY"] = 12] = "VASECTOMY";
  BirthControlMethod[BirthControlMethod["FEMALE_STERILISATION"] = 13] = "FEMALE_STERILISATION";
  return BirthControlMethod;
}(BirthControlMethod || {});